module.exports = __webpack_public_path__ + "static/media/google-play.842eee5d.svg";